import ErrorPage from '@apps-common/ui-components/ErrorPage.jsx';
import AccountStatusAlertBanners from '@components/dataCollections/collections/AccountStatusAlertBanners.tsx';
import AppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';
import LoadingMessage from '@src/components/common/LoadingMessage.tsx';
import {useImpersonationAwareAuth} from '@src/hooks/dataCollections/impersonation/useImpersonationAwareAuth.ts';
import {Outlet} from 'react-router';
import ImpersonationBanner from './collections/ImpersonationBanner.tsx';

const bannerSx = {marginBlockStart: 4, marginInline: 5};

const DataCollectionsLayout = () => {
  const {impersonation} = useImpersonationAwareAuth();

  if (impersonation.isImpersonating && impersonation.isLoading) {
    return <LoadingMessage />;
  }

  if (impersonation.isImpersonating && impersonation.isImpersonationDenied) {
    return <ErrorPage message="the page was not found" statusCode={404} />;
  }

  return (
    <Stack
      sx={{
        blockSize: '100%',
        inlineSize: '100%',
        overflow: 'auto',
      }}
    >
      <AppBar position="sticky" elevation={0}>
        <AccountStatusAlertBanners sx={bannerSx} />
        <ImpersonationBanner sx={bannerSx} />
      </AppBar>
      <Outlet />
    </Stack>
  );
};

export default DataCollectionsLayout;
